import React from 'react';
import './app.scss';
import { BrowserRouter as Router, Route} from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import HomeScreen from './HomeScreen/HomeScreen';
import ProductPage from './ProductPage/ProductPage';
import HotelPage from './DDD/Hotel';
import Carbon from './E-commerce/Carbon';
import Ak from './ITCompany/Ak';
import Portfolio from './Portfolio/Portfolio';
import RealEstate from './RealEstate/RealEstate';



function App() {
    return (
        <Router>
            <div className="app">
                <Navbar />
                <Route exact path="/"><HomeScreen /></Route>
                <Route exact path="/sass"><ProductPage /></Route>
                <Route exact path="/ddd"><HotelPage /></Route>
                <Route exact path="/carbon"><Carbon /></Route>
                <Route exact path="/ak"><Ak /></Route>
                <Route exact path="/martin"><Portfolio /></Route>
                <Route exact path="/crsa"><RealEstate /></Route>
            </div>
        </Router>
    )
}

export default App;
